import { render, staticRenderFns } from "./FactorsOverview.vue?vue&type=template&id=64af5d2f&"
import script from "./FactorsOverview.vue?vue&type=script&lang=js&"
export * from "./FactorsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports